import { t } from "i18next";

// Table field config
export const columnsORG = [
  {
    label: "ec53a8c4f0",
    accessor: "onlineStatus",
    sortable: true,
  },
  {
    label: "e7f4b6ea50",
    accessor: "macAddress",
    sortable: true,
  },
  {
    label: "e7d22294bd",
    accessor: "uid",
    sortable: true,
  },
  {
    label: "e86922432f",
    accessor: "serialNumber",
    sortable: true,
  },
  {
    label: "f6b4b7df89",
    accessor: "modelName",
    sortable: true,
  },
  {
    label: "92394ac496",
    accessor: "name",
    sortable: true,
  },
  {
    label: "a7d6475ec8",
    accessor: "siteName",
    sortable: true,
  },
  {
    label: "cce99c598c",
    accessor: "profileName",
    sortable: true,
  },
  {
    label: "c74b160828",
    accessor: "licenseState",
    sortable: true,
  },
  {
    label: "6d27700100",
    accessor: "activationDate",
    sortable: true,
  },
  {
    label: "53f289dc8e",
    accessor: "expirationDate",
    sortable: true,
  },
];

export const columnsMSP = [
  {
    label: "ec53a8c4f0",
    accessor: "onlineStatus",
    sortable: true,
  },
  {
    label: "e7f4b6ea50",
    accessor: "macAddress",
    sortable: true,
  },
  {
    label: "e7d22294bd",
    accessor: "uid",
    sortable: true,
  },
  {
    label: "e86922432f",
    accessor: "serialNumber",
    sortable: true,
  },
  {
    label: "f6b4b7df89",
    accessor: "modelName",
    sortable: true,
  },
  {
    label: "92394ac496",
    accessor: "name",
    sortable: true,
  },
  {
    label: "d6b258792f",
    accessor: "organization",
    sortable: true,
  },
  {
    label: "c9772a79fb",
    accessor: "organizationId",
    sortable: true,
  },
  {
    label: "91f867cbb6",
    accessor: "level",
    sortable: true,
  },
  {
    label: "a7d6475ec8",
    accessor: "siteName",
    sortable: true,
  },
  {
    label: "cce99c598c",
    accessor: "profileName",
    sortable: true,
  },
  {
    label: "5d5c4ad5db",
    accessor: "licenseKey",
    sortable: true,
  },
  {
    label: "c74b160828",
    accessor: "licenseState",
    sortable: true,
  },
  {
    label: "6d27700100",
    accessor: "activationDate",
    sortable: true,
  },
  {
    label: "53f289dc8e",
    accessor: "expirationDate",
    sortable: true,
  },
];

export const defaultMessages = {
  success: null,
  error: null,
  warning: null,
  generateError: null,
};

export const deviceTypeMapping = {
  DBG: "gateway",
  DBA: "ap",
  DBS: "switch",
};

export const orgListLimit = 10;

export const licenseListLimit = 10;

export const defaultDropdownStatusList = [
  { title: "b1c94ca2fb", value: "All", isActive: true },
  { title: "54f664c70c", value: "Online", isActive: false },
  { title: "8d9da4bc0e", value: "Offline", isActive: false },
  { title: "96542608b4", value: "Dormant", isActive: false },
];

export const defaultDropdownProductCategoryList = [
  { title: "b1c94ca2fb", value: "All", isActive: true },
  { title: "cb3f9a1103", value: "AP", isActive: false },
  { title: "bbc155fb2b", value: "Switch", isActive: false },
  { title: "926dec9494", value: "Gateway", isActive: false },
];

export const defaultDropdownModelNameList = [
  { title: "b1c94ca2fb", value: "All", sActive: true },
  { title: "DBA-1210P", value: "DBA-1210P", isActive: false },
  { title: "DBA-1510P", value: "DBA-1510P", isActive: false },
  { title: "DBA-1520P", value: "DBA-1520P", isActive: false },
  { title: "DBA-2520P", value: "DBA-2520P", isActive: false },
  { title: "DBA-2720P", value: "DBA-2720P", isActive: false },
  { title: "DBA-2820P", value: "DBA-2820P", isActive: false },
  { title: "DBA-3621P", value: "DBA-3621P", isActive: false },
  { title: "DBA-X1230P", value: "DBA-X1230P", isActive: false },
  { title: "DBS-2000", value: "DBS-2000", isActive: false },
  { title: "DBG-2000", value: "DBG-2000", isActive: false },
  { title: "DBG-2000(B1)", value: "DBG-2000(B1)", isActive: false },
  { title: "DBG-X1000", value: "DBG-X1000", isActive: false },
];

export const defaultDropdownUsedUnusedList = [
  { title: "f6cb3e8164", value: "Both", isActive: true },
  { title: "c29fb273b8", value: "Used", isActive: false },
  { title: "8a73657240", value: "not Use", isActive: false },
];

export const defaultModalStatus = {
  addDevice: {
    status: false,
    disabled: false,
  },
  deleteDevice: {
    status: false,
    disabled: false,
  },
  assignTo: {
    status: false,
    disabled: false,
  },
  assignLicense: {
    status: false,
    disabled: false,
  },
};

export const defaultDevicelisting = {
  skipRecords: 0,
  sortField: "",
  sortOrder: 1,
};

export const deivceStatusList = [
  { title: "8a73657240", value: "Unused" },
  { title: "c29fb273b8", value: "Used" },
];

export const licenseTermList = [
  { title: "1 month", unit: "MONTH", period: 1 },
  { title: "1 year", unit: "YEAR", period: 1 },
  { title: "3 years", unit: "YEAR", period: 3 },
  { title: "5 years", unit: "YEAR", period: 5 },
];

export const defaultLicensesEnum = {
  DBA: {
    displayLimitation: 5,
    licenseTerms: [
      {
        selected: null,
        list: [
          {
            period: 1,
            remainingCount: 0,
            totalCount: 0,
            title: "1 Year",
          },
          {
            licenesList: [],
            period: 2,
            remainingCount: 0,
            totalCount: 0,
            title: "2 Years",
          },
          {
            period: 3,
            remainingCount: 0,
            totalCount: 0,
            title: "3 Years",
          },
          {
            period: 4,
            remainingCount: 0,
            totalCount: 0,
            title: "4 Years",
          },
          {
            period: 5,
            remainingCount: 0,
            totalCount: 0,
            title: "5 Years",
          },
          {
            period: 7,
            remainingCount: 0,
            totalCount: 0,
            title: "7 Years",
          },
        ],
      },
    ],
  },
  DBS: {
    displayLimitation: 5,
    licenseTerms: [
      {
        selected: null,
        list: [
          {
            period: 1,
            remainingCount: 0,
            totalCount: 0,
            title: "1 Year",
          },
          {
            period: 2,
            remainingCount: 0,
            totalCount: 0,
            title: "2 Years",
          },
          {
            period: 3,
            remainingCount: 0,
            totalCount: 0,
            title: "3 Years",
          },
          {
            period: 4,
            remainingCount: 0,
            totalCount: 0,
            title: "4 Years",
          },
          {
            licenesList: [],
            period: 5,
            remainingCount: 0,
            totalCount: 0,
            title: "5 Years",
          },
          {
            period: 7,
            remainingCount: 0,
            totalCount: 0,
            title: "7 Years",
          },
        ],
      },
    ],
  },
  DBG: {
    displayLimitation: 5,
    licenseTerms: [
      {
        selected: null,
        list: [
          {
            period: 1,
            remainingCount: 0,
            totalCount: 0,
            title: "1 Year",
          },
          {
            period: 2,
            remainingCount: 0,
            totalCount: 0,
            title: "2 Years",
          },
          {
            period: 3,
            remainingCount: 0,
            totalCount: 0,
            title: "3 Years",
          },
          {
            period: 4,
            remainingCount: 0,
            totalCount: 0,
            title: "4 Years",
          },
          {
            period: 5,
            remainingCount: 0,
            totalCount: 0,
            title: "5 Years",
          },
          {
            period: 7,
            remainingCount: 0,
            totalCount: 0,
            title: "7 Years",
          },
        ],
      },
    ],
  },
};

export const fakeCountryList = [
  {
    title: "Afghanistan",
    timeZone: [{ title: "Asia/Kabul(UTC+04:30, DST)" }],
  },
  {
    title: "Aland Islands",
    timeZone: [{ title: "Europe/Mariehamn(UTC+02:00, DST)" }],
  },
  {
    title: "Albania",
    timeZone: [{ title: "Europe/Tirane(UTC+01:00, DST)" }],
  },
  {
    title: "Antarctica",
    timeZone: [
      { title: "Antarctica/Casey(UTC+11:00, DST)" },
      { title: "Antarctica/Davis(UTC+07:00, DST)" },
      { title: "Antarctica/DumontDUrville(UTC+10:00, DST)" },
    ],
  },
];

export const fakeAssignLicenseTermList = [
  { title: "1 year" },
  { title: "2 years" },
  { title: "3 years" },
  { title: "4 years" },
  { title: "5 years" },
  { title: "7 years" },
];
